
<div class="overlay active"
     *ngIf="isDiscardModalOpen"></div>

<div swqModal class="modal slide-left container wsection" [class.active]="swqModalStatusModel.swqModalIsOpen" id="divCommonHeader"></div>

<ng-template sw-discard-host></ng-template>

<div swProcess class="container wsection captchaModel" id="section_wise_container"></div>
